module.exports = __webpack_public_path__ + "static/1-ba6264f2c08816054d9816af26f097d4.png";